import { GetListResponse, instance } from "libs/api";

import { ApiRoutesTransactions } from "../../constants";
import { TransactionItem } from "../../financial.types";
import { TransactionsRequestParams } from "./transactions.types";

export const requestTransactions = async (
  params: TransactionsRequestParams
): Promise<GetListResponse<TransactionItem>> => {
  return await instance.get(ApiRoutesTransactions.Transactions, {
    params
  });
};
